import {createApi} from '@reduxjs/toolkit/query/react'
import axios from 'axios'
import baseUrl from './baseUrl'

export const provideTag = (tagName, data, tagField) => {
    return data ? [{type: tagName, id: data[tagField || '_id']}] : [{type: tagName, id: 'LIST'}]
}

export const baseRequest = async (baseUrl, url, method, body, headers) => {
    return await axios({
        url: `${baseUrl}/${url}`,
        method,
        data: body,
        withCredentials: true,
        ...(headers && {headers: headers({})}),
    })
}

const axiosErrorHandler = async (error, baseUrl, url, method, body, headers) => {
    if (error.response?.status !== 401 || url === 'auth/refreshToken') return null

    try {
        await baseRequest(baseUrl, 'auth/refreshToken', 'GET', null, headers)
        const retryResponse = await baseRequest(baseUrl, url, method, body, headers)
        return {data: retryResponse.data}
    } catch (refreshError) {
        return {
            error: {
                status: refreshError.response?.status,
                data: refreshError.response?.data,
            },
        }
    }
}
const baseQuery =
    ({baseUrl, headers} = {baseUrl: '', headers: ''}) =>
    async ({url, method, body}) => {
        try {
            const response = await baseRequest(baseUrl, url, method, body, headers)
            return {data: response.data}
        } catch (err) {
            const responseError = {
                error: {
                    status: err.response?.status,
                    data: err.response?.data,
                },
            }
            console.log(responseError, 'responseError')
            const retryResult = await axiosErrorHandler(err, baseUrl, url, method, body, headers)
            if (retryResult) {
                return retryResult
            }
            return responseError
        }
    }

const getHeaders = () => {
    return {
        Accept: 'application/json',
    }
}

export const API_TAGS = [
    'CurrentUser',
    'Account',
    'User',
    'Structure',
    'Consumer',
    'Meter',
    'Rate',
    'MeterReading',
    'Invoice',
    'FaultLog',
    'Account_Report',
    'Invite',
    'Config',
    'Queue',
    'CurrentRate',
    'DailyMeterReading',
    'UserAccounts',
    'PermissionsCatalog',
    'UserPermissions',
    'EmailBroadcast',
    'AuditLog',
]

const baseApi = createApi({
    baseQuery: baseQuery({
        baseUrl: baseUrl,
        headers: () => getHeaders(),
    }),
    reducerPath: 'api',
    tagTypes: API_TAGS,
    endpoints: () => ({}),
})

export default baseApi
